/**
 * Central configuration for the frontend application.
 *
 * All environment-dependent values (URLs, ports, feature flags) are
 * exposed from this single module so that every other file can import
 * them instead of scattering `import.meta.env.*` look-ups across the
 * codebase.
 */

export const PRODUCTION_API_BASE_URL = 'https://api.trivoa.app/api';

export function resolveApiBaseUrl(isProduction: boolean, configuredValue?: string): string {
  const configuredBaseUrl = configuredValue?.trim();
  const baseUrl = isProduction
    ? PRODUCTION_API_BASE_URL
    : configuredBaseUrl || '/api';
  return baseUrl.replace(/\/+$/, '');
}

/** Base URL for every application API call. Signed object-storage URLs are the only exception. */
export const API_BASE_URL: string = resolveApiBaseUrl(
  import.meta.env.PROD,
  import.meta.env.VITE_API_BASE_URL,
);

/** Full backend origin used by the Vite dev-server proxy (not used at runtime in the browser). */
export const BACKEND_URL: string = import.meta.env.VITE_BACKEND_URL || 'http://127.0.0.1:8787';

/** Current environment label. */
export const ENVIRONMENT: string = import.meta.env.VITE_ENVIRONMENT || 'development';

/** Whether the app is in development / "dev-mode". */
export const IS_DEV: boolean = import.meta.env.VITE_DEV_MODE === 'true' || import.meta.env.DEV;
